export const version = '2.0.0-dev1494';
